import { c as _c } from "react/compiler-runtime";
import { Box, Grid } from "@mui-wrapper";
import { withEllipsis } from "@styles/common-styles";
/** Content for the center of layout header */
export function HeaderLayoutCenter(t0) {
  const $ = _c(4);
  const {
    centerComponent
  } = t0;
  if (!centerComponent) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      ...withEllipsis,
      alignItems: "center"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      px: "10px",
      ...withEllipsis
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== centerComponent) {
    t3 = <Grid sx={t1}><Box component="div" sx={t2}>{centerComponent}</Box></Grid>;
    $[2] = centerComponent;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}